import {snackbarMessage} from 'actions/snackbar'
import types from 'actions/types'
import {generalError} from 'actions/index'
import {all, call, delay, put, select, takeLatest} from 'redux-saga/effects'
import {textTranslated} from 'actions/language'
import {getPendingTranslations, getTargetLanguage} from 'selectors/language'
import {uniq} from 'lodash'

export default (api) => {

  function* translateText() {

    yield delay(500)

    try {
      const pendingTranslations = yield select(getPendingTranslations)
      const text = uniq(pendingTranslations)

      const language = yield select(getTargetLanguage)
      const response = yield call(api.language.translate, {text, language})

      yield api.handleResponse(
          response,
          function* onOk(key, data) {
            yield put(textTranslated(data.result))
          },
          function* onFail(key, message) {
            console.error(message)
            yield put(snackbarMessage('Failed to translate', 'error', false))
          }
      )
    } catch (e) {
      console.error(e)
      yield put(snackbarMessage(
          'Problem connecting to Google Drive. ' + e.message,
          'error',
          false))
    }
  }

  function* watcher() {
    try {
      yield all([
        takeLatest(types.LANGUAGE_TRANSLATE_TEXT, translateText),
      ])

    } catch (e) {
      console.error(e)
      yield put(generalError())
    }
  }

  return {
    watcher,
  }
}
